var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSellerChose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.584 15.007H3.039c-.603 0-1.091-.488-1.092-1.09V3.037c.001-.602.49-1.09 1.092-1.09h10.877c.602 0 1.09.488 1.091 1.09V8.04a.466.466 0 10.933 0V3.037a2.025 2.025 0 00-2.024-2.022H3.039a2.024 2.024 0 00-2.024 2.022v10.88c0 1.117.906 2.023 2.024 2.023h5.545a.466.466 0 100-.933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67 3.822a.466.466 0 00-.467.467V6.2c0 1.786 1.465 3.237 3.265 3.237s3.265-1.451 3.265-3.237V4.29a.466.466 0 10-.933 0V6.2c0 1.272-1.047 2.304-2.332 2.304-1.287 0-2.332-1.032-2.332-2.304V4.29a.466.466 0 00-.467-.467M15 14.767a.235.235 0 01-.237.233h-3.526a.235.235 0 01-.237-.233v-2.533c0-.13.106-.234.237-.234h3.526c.13 0 .237.104.237.233v2.534h0zM14.89 11h-3.78c-.612 0-1.11.5-1.11 1.116v2.768c0 .615.498 1.116 1.11 1.116h3.78c.612 0 1.11-.5 1.11-1.116v-2.767c0-.616-.497-1.117-1.11-1.117h0z"
  }))));
}
export default SvgSellerChose;